/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Egdatarating2Inputs */

const id_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat EGDATA`)
};

const ms_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian EGDATA`)
};

const da_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Bedømmelse`)
};

const de_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-Bewertung`)
};

const en_us2_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Rating`)
};

const es_es2_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación EGDATA`)
};

const es_mx2_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación EGDATA`)
};

const fil_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng EGDATA`)
};

const fr_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note EGDATA`)
};

const it_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione EGDATA`)
};

const hu_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA értékelés`)
};

const nl_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-beoordeling`)
};

const no_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-vurdering`)
};

const pl_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena EGDATA`)
};

const pt_br2_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação EGDATA`)
};

const pt_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação EGDATA`)
};

const ro_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluare EGDATA`)
};

const fi_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-arvio`)
};

const sv_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA-betyg`)
};

const vi_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng EGDATA`)
};

const tr_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA Puanı`)
};

const cs_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení EGDATA`)
};

const bg_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA оценка`)
};

const ru_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг EGDATA`)
};

const uk_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг EGDATA`)
};

const ar_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييم EGDATA`)
};

const hi_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA रेटिंग`)
};

const th_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนน EGDATA`)
};

const ja_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA レーティング`)
};

const zh_cn2_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA评分`)
};

const zh_hant1_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA評分`)
};

const ko_offerdetail_reviews_egdatarating2 = /** @type {(inputs: Offerdetail_Reviews_Egdatarating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EGDATA 평점`)
};

/**
* | output |
* | --- |
* | "EGDATA Rating" |
*
* @param {Offerdetail_Reviews_Egdatarating2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_egdatarating2 = /** @type {((inputs?: Offerdetail_Reviews_Egdatarating2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Egdatarating2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "da") return da_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "de") return de_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "it") return it_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "no") return no_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "th") return th_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_egdatarating2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_egdatarating2(inputs)
	return ko_offerdetail_reviews_egdatarating2(inputs)
});
export { offerdetail_reviews_egdatarating2 as "offerDetail.reviews.egdataRating" }